
import { defineComponent } from 'vue'
import { goto } from '@/helpers'
import Logo from '@/components/Icons/Logo.vue'
import OrangeButton from '@/components/Buttons/OrangeButton.vue'

export default defineComponent({
  components: { Logo, OrangeButton },
  methods: {
    goto,
  },
})
